module.exports = __webpack_public_path__ + "img/menuListBg.a057760d.png";